import { loadStripe } from "@stripe/stripe-js";

// Fonction qui permet de gérer la clé API Stripe à utiliser en fonction de l'url courante (API Stripe trial ou live)
export const loadStripeApiKey = () => {
	if (
		window.location.host === "dev.prevandcare.com"
		|| window.location.host === "v2.prevandcare.local:8890"
		|| window.location.host === "localhost:3001"
		|| window.location.host === "localhost:3000") {
		const stripePromise = loadStripe("pk_test_OycYQi3RjHDuqEcTAivflwqe00EOAgdQ0g");
		return stripePromise;
	} else if (window.location.host === "www.prevandcare.com") {
		const stripePromise = loadStripe("pk_live_CC5CkE8EM6ywbAxHd3BPeXvY00cFBGngoL");
		return stripePromise;
	} else {
		const stripePromise = loadStripe("pk_live_CC5CkE8EM6ywbAxHd3BPeXvY00cFBGngoL");
		return stripePromise;
	}
};